import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {IPaginatedRequest} from "../../types/IPaginatedRequest";
import {ILatestQuery} from "../../utils/latest_query";
import {IVendorOfferListResponse} from "../types/VendorOffersListResponse";

//  TODO: Analyze what is the actual payload for VendorOfferList and remove ILatestQuery from here
type IGetVendorOfferListPayload = IPaginatedRequest &
    Omit<ILatestQuery, "vendor"> & {
        vendor: number;
        country?: number[];
    };

const offerListApiLink = apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST);

export const getVendorOfferList = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getVendorOfferList: build.query<IVendorOfferListResponse, Omit<IGetVendorOfferListPayload, "page" | "page_size">>({
            query: (params) => ({
                url: offerListApiLink,
                params: {
                    page: 1,
                    page_size: 1000,
                    country: getCountriesList(),
                    ...params
                }
            })
        })
    })
});

export const {useGetVendorOfferListQuery} = getVendorOfferList;
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {IPaginatedRequest} from "../../types/IPaginatedRequest";
import {ILatestQuery} from "../../utils/latest_query";
import {IVendorOfferListResponse} from "../types/VendorOffersListResponse";

//  TODO: Analyze what is the actual payload for VendorOfferList and remove ILatestQuery from here
type IGetVendorOfferListPayload = IPaginatedRequest &
    Omit<ILatestQuery, "vendor"> & {
        vendor: number;
        country?: number[];
    };

const offerListApiLink = apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST);

export const getVendorOfferList = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getVendorOfferList: build.query<IVendorOfferListResponse, Omit<IGetVendorOfferListPayload, "page" | "page_size">>({
            query: (params) => ({
                url: offerListApiLink,
                params: {
                    page: 1,
                    page_size: 1000,
                    country: getCountriesList(),
                    ...params
                }
            })
        })
    })
});

export const {useGetVendorOfferListQuery} = getVendorOfferList;
